import { BaseModel } from '@shared/base.model';
import { ProgramPreQualificationCriteria } from './program-pre-qualification-criteria.model';

export class ProgramPreQualification extends BaseModel<ProgramPreQualification> {
  criterion: ProgramPreQualificationCriteria;
  preQualification: string;

  constructor(programPreQualificationInfo) {
    super();
    this.id = programPreQualificationInfo.id;
    this.criterion = new ProgramPreQualificationCriteria(programPreQualificationInfo.criterion || {});
    this.preQualification = programPreQualificationInfo.preQualification;
  }
}
